import { deleteObject, getBlob, getDownloadURL, getMetadata, listAll, ref, uploadBytes } from "firebase/storage"
import { auth, db, storage } from "../config/firebase"
import { FileType, initialUserUrls } from "./spName"
import { saveAs } from "file-saver";
import { UpdateUser } from "./users";
import { signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

export const UploadFileToFirebase = async (file, type, uid = auth.currentUser.uid) => {
    try {
        if (!auth.currentUser) {
            signOut(auth)
            throw new Error("โปรดเข้าสู่ระบบอีกครั้ง")
        }
        const storageRef = ref(storage, `${uid}/${type}`)
        const res = await uploadBytes(storageRef, file)
        const successRef = ref(storage, res.ref.fullPath)
        const url = await getDownloadURL(successRef)
        await UpdateUser({[FileType[type]] : true}, uid)
        alert('อัปโหลดไฟล์สำเร็จ')
        return url
    }
    catch (e) {
        switch (e.code) {
            case 'storage/unknown': default:
                alert(e.code, ' : ', e.message, 'โปรดติดต่อทีมงาน')
                break;
            case 'storage/quota-exceeded':
                alert(`storage/quota-exceeded : ขออภัย ฐานข้อมูลเต็ม โปรดติดต่อทีมงาน`);
                break;
            case 'storage/unauthenticated':
                alert(`storage/unauthenticated : ขออภัย อัปโหลดไม่สำเร็จ โปรดเข้าสู่ระบบใหม่`);
                break;
            case 'storage/unauthorized':
                alert(`storage/unauthorized : ขออภัย ท่านไม่สามารถอัปโหลดไฟลได้ โปรดติดต่อทีมงาน`);
                break;
            case 'storage/retry-limit-exceeded':
                alert(`storage/retry-limit-exceeded : ขออภัย ระบบอัปโหลดนานเกินไป ท่านอาจจะใช้ไฟล์ใหญ่เกินไป`);
                break;
        }
        console.log(e)
    }
    
}

export const onDownloadFileClick = async (filePath, fileName) => {
    try {
        const b = await getBlob(ref(storage, `${filePath}`))
        const blob = new Blob([b], { type : b.type })
        saveAs(blob, fileName)
    }
    catch(e) {
        alert('ขออภัย ไม่พบไฟล์')
        console.log(e)
    }
}

export const getFileURL = async (filepath) => {
    try {
        const r = ref(storage, `${filepath}`)
        const b = await getBlob(r)
        const m = await getMetadata(r)
        const blob = new Blob([b], { type : b.type })
        return {
            url : URL.createObjectURL(blob),
            type : b.type,
            size : `${parseInt(b.size/1000)} KB`,
            updated : new Date(m.updated).toLocaleString('th'),
        }
    }
    catch(e) {
        alert('ขออภัย ไม่พบไฟล์')
        console.log(e)
    }
}

export const GetOwnURLS = async (uid = auth.currentUser.uid) => {
    const storageRef = ref(storage, uid)
    const folders = await listAll(storageRef)
    let urls = {...initialUserUrls}
    let dbUrls = {}
    for (let i = 0; i < folders.items.length; i++) {
        let it = folders.items[i]
        if (FileType[it.name]) {
            urls = {...urls, [FileType[it.name]] : it.fullPath}
        }
    }
    for (const k in urls) {
        dbUrls = {...dbUrls, [k] : urls[k] ? true : false}
    }
    await UpdateUser(dbUrls, uid)
    return urls
}

export const UpdateFileStatus = async (uid) => {
    const storageRef = ref(storage, uid)
    const folders = await listAll(storageRef)
    const user = await getDoc(doc(db, 'users', uid))
    for (let i = 0; i < folders.items.length; i++) {
        let it = folders.items[i]
        let code = FileType[it.name]
        if (code && user.data()[code] === false) {
            await UpdateUser({ [code] : true }, uid)
            console.log(`FILE INCORRECT (false -> true) : ${user.id} ${user.data().round} ${user.data().nameEN} ${it.name} `)
        }
    }
}

/*export const GetEnabledURLS = async (loadingUrlsRef) => {
    const allStorageRef = ref(storage, '/')
    let t = Date.now()
    const folders = await listAll(allStorageRef)
    console.log(Date.now() - t)
    
    let uidArray = []
    folders.prefixes.forEach(folderRef => {
        uidArray = [...uidArray, folderRef.fullPath]
    })
    const total = uidArray.length

    let urls = {}
    for (let i = 0; i < uidArray.length; i++) {
        const uid = uidArray[i]
        const rootRef = ref(storage, uid)
        const it = (await listAll(rootRef)).items;
        for (let j = 0; j < it.length; j++) {
            const t = it[j].fullPath.split('/')[1]
            urls = {...urls, [uid] : {...urls[uid], [FileType[t]] : it[j].fullPath}}
        }
        loadingUrlsRef.current = (i + 1) * 100 / total
        //setLoadingUrls((i + 1) * 100 / total)
    }
    return urls
}*/

export const RemoveFile = async (type, uid=auth.currentUser.uid) => {
    try {
        const storageRef = ref(storage, `${uid}/${type}`)
        await deleteObject(storageRef)
        UpdateUser({[FileType[type]] : false}, uid)
        alert('ลบไฟล์ ' + type + ' สำเร็จ')
    }
    catch(e) {
        alert('ขออภัย ลบไฟล์ผิดพลาด')
        console.log(e)
    }
}
